import { Component, inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DxDrawerModule, DxDrawerTypes } from 'devextreme-angular/ui/drawer';
import { DxScrollViewComponent } from 'devextreme-angular/ui/scroll-view';
import { DxTreeViewTypes } from 'devextreme-angular/ui/tree-view';

import { Event, NavigationEnd, Router, RouterModule } from '@angular/router';
import { clearListFilterQueryParams } from 'src/app/shared/helpers/list-navigation.helper';
import { HeaderComponent, SideNavigationMenuComponent } from '../../components';
import { ScreenService } from '../../shared/services';

import { Subscription } from 'rxjs';

@Component({
    selector: 'app-side-nav-outer-toolbar',
    templateUrl: './side-nav-outer-toolbar.component.html',
    styleUrls: ['./side-nav-outer-toolbar.component.scss'],
    standalone: true,
    imports: [RouterModule, SideNavigationMenuComponent, DxDrawerModule, HeaderComponent],
})
export class SideNavOuterToolbarComponent implements OnInit, OnDestroy {
    private readonly screen = inject(ScreenService);
    private readonly router = inject(Router);

    @ViewChild(DxScrollViewComponent, { static: true }) scrollView!: DxScrollViewComponent;

    @Input()
    title!: string;

    @Input()
    showMenu = true;

    selectedRoute = '';

    menuOpened!: boolean;

    temporaryMenuOpened = false;

    menuMode: DxDrawerTypes.OpenedStateMode = 'shrink';

    menuRevealMode: DxDrawerTypes.RevealMode = 'expand';

    minMenuSize = 0;

    shaderEnabled = false;

    routerSubscription: Subscription;

    screenSubscription: Subscription;

    public get currentYear() {
        return new Date().getFullYear();
    }

    constructor() {
        this.routerSubscription = this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                const url = event.urlAfterRedirects.split('?')[0];
                this.selectedRoute = this.getMatchingRoute(url);
            }
        });
    }

    private getMatchingRoute(url: string): string {
        if (url.startsWith('/customers/')) {
            return '/customers';
        }

        // Handle other route patterns as needed
        // For now, return the exact URL for other routes
        return url;
    }

    ngOnInit() {
        this.menuOpened = false;

        this.screenSubscription = this.screen.changed.subscribe(() => this.updateDrawer());

        this.updateDrawer();
    }

    ngOnDestroy(): void {
        this.routerSubscription?.unsubscribe();
        this.screenSubscription?.unsubscribe();
    }

    updateDrawer() {
        const isXSmall = this.screen.sizes['screen-x-small'];
        // const isLarge = this.screen.sizes['screen-large'];

        this.menuMode = 'shrink'; //isLarge ? 'shrink' : 'overlap';
        this.menuRevealMode = isXSmall ? 'slide' : 'expand';
        this.minMenuSize = isXSmall ? 0 : 48;
        // this.shaderEnabled = !isLarge;
    }

    get hideMenuAfterNavigation() {
        return this.menuMode === 'overlap' || this.temporaryMenuOpened;
    }

    get showMenuAfterClick() {
        return !this.menuOpened;
    }

    navigationChanged(event: DxTreeViewTypes.ItemClickEvent) {
        const path = (event.itemData as any).path;
        const pointerEvent = event.event;

        if (path && this.menuOpened) {
            if (event.node?.selected) {
                void this.router.navigate([path], {
                    queryParams: clearListFilterQueryParams(),
                    queryParamsHandling: 'merge',
                });
                pointerEvent?.preventDefault();
            } else {
                this.router.navigate([path]);
            }

            if (this.hideMenuAfterNavigation) {
                this.temporaryMenuOpened = false;
                this.menuOpened = false;
                pointerEvent?.stopPropagation();
            }
        } else {
            pointerEvent?.preventDefault();
        }
    }

    navigationClick() {
        if (this.showMenuAfterClick) {
            this.temporaryMenuOpened = true;
            this.menuOpened = true;
        }
    }
}
